const state = {
    WhiteRoute: [
        {
            path: '/',
            component: () => import('@/view/home/HomePage'),
            meta: {
                title: "首页",
                icon: 'fa fa-home fa-lg'
            },
            name: "home",

        },

        {
            path: '/order',
            component: () => import('@/view/home/OederPage'),
            meta: {
                title: "产品详情",
                icon: 'fa fa-home fa-lg'
            },
            name: "order",
            hidden: true

        },

        {
            path: '/speed',
            component: () => import('@/view/speed/SpeedPage'),
            meta: {
                title: "工程进度",
                icon: "fa fa-list fa-lg"

            },
            name: "speed",


        },
        {
            path: '/designer',
            component: () => import('@/view/designer/DesignerPage'),
            meta: {
                title: "设计进度",
                icon: "fa fa-linode fa-lg"

            },
            name: "speed",


        },

        {
            path: '/message',
            component: () => import('@/view/MessagePage/MessagePage'),
            meta: {
                title: "消息中心",
                icon: "fa fa-bell-o fa-lg"
            },
            name: "message",

        },
        {
            path: '/404',
            component: () => import('@/view/PagesNotFound'),
            hidden: true,
            meta: {
                title: "404页面"
            },
            name: "404"
        },
        {path: '*', redirect: '/404', hidden: true}


    ],
    LoginRoute: [
        {
            path: '/addbudget',
            component: () => import('@/view/BudgetPage/AddBudgetPage'),
            hidden: true,
            meta: {
                title: "添加报价",
                icon: "fa fa-tasks"

            },
            name: "addbudget",


        },
        {
            path: '/MaterialType',
            component: () => import('@/view/MaterialPage/MaterialType'),
            meta: {
                title: "材料指定",
                icon: 'fa fa-home fa-lg'
            },
            name: "materialtype",
            hidden: true

        },
        {
            path: '/editbudget',
            component: () => import('@/view/BudgetPage/EditBudgetPage'),
            hidden: true,
            meta: {
                title: "修改报价",
                icon: "fa fa-tasks"

            },
            name: "editbudget",


        },
        {
            path: '/workcomp',
            component: () => import('@/view/CostPage/WorkComp'),
            hidden: true,
            meta: {
                title: "查看工量表",
                icon: "fa fa-tasks"

            },
            name: "workcomp",


        },
        {
            path: '/costwork',
            component: () => import('@/view/CostPage/CostWork'),
            hidden: true,
            meta: {
                title: "查看工量表",
                icon: "fa fa-tasks"

            },
            name: "costwork",


        },
        {
            path: '/laborwork',
            component: () => import('@/view/LaborPage/LaborWrokType'),
            hidden: true,
            meta: {
                title: "工费操作",
                icon: "fa fa-tasks"

            },
            name: "laborwork",

        },
        {

            path: '/work',
            component: () => import('@/view/work/WorkPage'),
            redirect: '/material',
            meta: {
                title: "工作区",
                icon: "fa fa-list-ol fa-lg "
            },
            name: "work",
            children: [
                {
                    path: '/material',
                    component: () => import('@/view/MaterialPage/MaterialPage'),
                    meta: {
                        title: "选材料",
                        icon: "fa fa-tasks"

                    },
                    name: "material",


                },
                {
                    path: '/budget',
                    component: () => import('@/view/BudgetPage/BudgetPage'),
                    meta: {
                        title: "报价",
                        icon: "fa fa-building-o"

                    },
                    name: "budget",


                },
                {
                    path: '/cost',
                    component: () => import('@/view/CostPage/CostPage'),
                    meta: {
                        title: "工程量",
                        icon: "fa fa-bookmark"

                    },
                    name: "budget",


                },
                {
                    path: '/labor',
                    component: () => import('@/view/LaborPage/LaborPage'),
                    meta: {
                        title: "工费查看",
                        icon: "fa fa-briefcase"

                    },
                    name: "labor",


                },
                

            ]
        },

    ]


}


export default {
    namespaced: true,
    state,
}
